<template>
  <ez-user-modal
    ref="userModal"
    :formKey="formKey"
    :formAction="formAction"
    :user="user"
    @close="reset"
    @success="onSubmitSuccess">
    <EzRolesList
      ref="roles"
      :group-id="groupId"
      :formKey="formKey"
      :user="user"
      :roles="roles"
      :venues="venues" />
  </ez-user-modal>
</template>

<script>
import EzRolesList from '@/views/common/users/EzRolesList.vue';
import { EzUserModal } from '@/views/common/users';
import User from '@/models/User';
import Venue from '@/models/Venue';
import flash from '@/components/ui/FlashMessage';

export default {
  components: {
    EzRolesList,
    EzUserModal,
  },
  props: {
    groupId: {
      type: Number,
      required: true,
    },
    userId: {
      type: Number,
    },
    roles: {
      type: Array,
    },
  },
  data() {
    return {
      formKey: 'venue-user',
      allowGroupPermissionsInternal: false,
    };
  },
  computed: {
    formAction() {
      const isAdmin = localStorage.getItem('role') === 'admin';

      if (isAdmin) {
        return `/admin/venue-groups/${this.groupId}/users`;
      }

      return '/venue-group/users';
    },
    venues() {
      const venues = Venue.query()
        .where('groupId', this.groupId)
        .all();

      return [
        ...venues,
      ];
    },
    user() {
      const defaultUser = {
        role: { key: null },
        venue: {},
      };

      return User.query()
        .with('venue')
        .find(this.userId) || defaultUser;
    },
    allowGroupPermissions: {
      get() {
        return this.allowGroupPermissionsInternal;
      },
      set(value) {
        this.allowGroupPermissionsInternal = value;
      },
    },
  },
  methods: {
    open() {
      this.$refs.userModal.open();
    },
    close() {
      this.$refs.userModal.close();
    },
    reset() {
      this.$refs.roles.reset();
    },
    onSubmitSuccess({ data, isUpdate }) {
      User.insertOrUpdate({ data: { ...data.data, groupId: this.groupId } });
      flash.success({ title: `User successfully ${isUpdate ? 'updated' : 'added'}.` });
      this.close();
    },
  },
};
</script>

<style scoped lang="scss">
  .user-permissions {
    @include separator();
    .ez-dropdown + .ez-dropdown {
      margin-top: .75rem;
    }
    .ez-checkbox {
      margin: 1rem 0;
    }
  }
</style>
